var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4953",
    "data-name": "Grupo 4953",
    transform: "translate(-10080 -4949)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_143",
    "data-name": "Elipse 143",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(10080 4949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook",
    "data-name": "Icon awesome-facebook",
    d: "M27.746,14.154A13.592,13.592,0,1,0,12.031,27.582v-9.5H8.578V14.154h3.453V11.16c0-3.406,2.028-5.288,5.134-5.288a20.917,20.917,0,0,1,3.043.265V9.48H18.493A1.964,1.964,0,0,0,16.278,11.6v2.551h3.77l-.6,3.929H16.278v9.5A13.6,13.6,0,0,0,27.746,14.154Z",
    transform: "translate(10090.438 4959.438)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbCircle);
export default __webpack_public_path__ + "static/media/FB-circle.0b33925682d01b6ef5f40e2dc5559a4d.svg";
export { ForwardRef as ReactComponent };